
import { css } from 'lit';
export default css`
pc-footer [slot='primary'] > *:last-child{
  flex:1;
}

pc-footer [slot='primary'] .footer-menu{
  gap:var(--spacing-6);
  columns:2;
}

pc-footer [slot='primary'] .footer-menu .column{
  margin-bottom:var(--spacing-6);
}

pc-footer [slot='primary'] .footer-menu .column > ul{
  display:flex;
  flex-direction:column;
  gap:var(--spacing-6);
}

pc-footer [slot='ancillary'] .footer-utility{
  columns:2;
  gap:var(--spacing-6);
}

pc-footer [slot='ancillary'] .footer-utility li{
  margin-bottom:var(--spacing-6);
}

pc-footer [slot='ancillary'] .footer-social-networks{
  display:flex;
  gap:var(--spacing-8);
}

pc-footer [slot='ancillary'] .footer-copyright{
  font-size:var(--fs-caption);
  line-height:var(--lh-caption);
  margin-top:var(--spacing-2);
}

@media (min-width: 768px){
  pc-footer [slot='ancillary'] .footer-utility{
    columns:2;
  }
}

@media (min-width: 992px){
  pc-footer [slot='primary'] .footer-menu{
    display:flex;
    justify-content:space-between;
  }

  pc-footer [slot='primary'] .footer-menu .column{
    margin-bottom:0;
  }

  pc-footer [slot='ancillary'] .footer-copyright{
    margin-top:0;
  }

  pc-footer [slot='ancillary'] .footer-utility{
    display:flex;
    gap:var(--spacing-6);
    columns:unset;
  }

  pc-footer [slot='ancillary'] .footer-utility li{
    margin-bottom:0;
  }
}
`;